module.exports = __webpack_public_path__ + "img/ill1.d0aa45cd.svg";